import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../utils/axiosInstance';

export const login = createAsyncThunk(
  'auth/login',
  async (credentials: { email: string; password: string }, thunkAPI) => {
    try {
      // #28: JWT тримаємо лише в пам'яті (redux), refresh-токен — httpOnly cookie (ставить бекенд).
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Auth/SignIn`,
        credentials,
        { withCredentials: true },
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return thunkAPI.rejectWithValue(error.response?.data);
      } else {
        return thunkAPI.rejectWithValue({
          message: 'An unknown error occurred',
        });
      }
    }
  },
);

export const refreshJwtToken = createAsyncThunk(
  'auth/refreshJwtToken',
  async (_, thunkAPI) => {
    try {
      // #28: refresh-токен передається httpOnly cookie (withCredentials), не з JS.
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Auth/Refresh`,
        {},
        { withCredentials: true },
      );
      return response.data; // jwtToken потрапляє в redux (in-memory)
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return thunkAPI.rejectWithValue(error.response?.data);
      } else {
        return thunkAPI.rejectWithValue({
          message: 'An unknown error occurred',
        });
      }
    }
  },
);

export const performLogout = createAsyncThunk(
  'auth/logout',
  async (_, thunkAPI) => {
    try {
      // #28: відкликати сесію на бекенді (чистить httpOnly cookie + revoke refresh).
      try {
        await axiosInstance.post('/Auth/LogOut', { deviceId: '' });
      } catch {
        // навіть якщо мережа впала — все одно чистимо локальний стан нижче
      }
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('reduxState');
      return;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return thunkAPI.rejectWithValue(error.response?.data);
      } else {
        return thunkAPI.rejectWithValue({
          message: 'An unknown error occurred',
        });
      }
    }
  },
);
